import React from 'react';
import  '../styles/RightWidgets.css';
import InfoIcon from "@material-ui/icons/Info";
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";

function RightWidgets(props) {

    const newsArticle =(heading, subtitle) =>(
        <div className="widget_article">
                <div className="article_left">
                    <FiberManualRecordIcon/>
                </div>
                <div className="article_right">
                    <h5>{heading}</h5>
                    <p>{subtitle}</p>
                </div>
        </div>
    );

    return (
        <div className="linkedin-right-widgets">
            <div className="widget_header">
                <h2>LinkedIn News</h2>
                <InfoIcon/>
            </div>
            {newsArticle("Developed by Prakash","News reader-1001")}
            {newsArticle("Corona virus: India Updates","News reader-9009")}
            {newsArticle("CryptoCurrency: what's new ?","News reader-2361")}
            {newsArticle("AI: The next big thing","News reader-8730")}
        </div>
    );
}

export default RightWidgets;